export const cryptoskillDevToolsExtraData = [
  {
    id: 'alchemy-api',
    name: 'Alchemy API',
    description: 'Access Alchemy enhanced APIs including NFT, Transfers, and Trace API for deep blockchain data insights.',
    author: 'Alchemy',
    version: '1.0.0',
    downloads: 124000,
    rating: 4.8,
    tags: ['api', 'data', 'infrastructure', 'alchemy'],
    category: 'dev-tools',
    githubUrl: 'https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/dev-tools/alchemy-api',
  },
  {
    id: 'alchemy-official-skill',
    name: 'Alchemy Official Skill',
    description: 'Official Alchemy skill for blockchain node access, WebSocket subscriptions, and enhanced API queries.',
    author: 'Alchemy',
    version: '2.1.0',
    downloads: 98000,
    rating: 4.9,
    tags: ['official', 'api', 'node', 'alchemy'],
    category: 'dev-tools',
    githubUrl: 'https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/dev-tools/alchemy-official-skill',
  },
  {
    id: 'alchemy-web3',
    name: 'Alchemy Web3',
    description: 'Web3.js wrapper optimized for Alchemy with automatic retries, enhanced debugging, and batch requests.',
    author: 'Alchemy',
    version: '1.3.0',
    downloads: 87000,
    rating: 4.7,
    tags: ['web3', 'sdk', 'alchemy', 'ethereum'],
    category: 'dev-tools',
    githubUrl: 'https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/dev-tools/alchemy-web3',
  },
  {
    id: 'arca-a3stack',
    name: 'Arca A3Stack',
    description: 'Full-stack Arca development toolkit with A3Stack for rapid smart contract deployment and testing.',
    author: 'Arca',
    version: '1.0.0',
    downloads: 12000,
    rating: 4.5,
    tags: ['stack', 'deployment', 'testing', 'arca'],
    category: 'dev-tools',
    githubUrl: 'https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/dev-tools/arca-a3stack',
  },
  {
    id: 'arca-agent',
    name: 'Arca Agent',
    description: 'Arca AI agent for automated contract analysis, gas optimization, and security recommendations.',
    author: 'Arca',
    version: '1.1.0',
    downloads: 15000,
    rating: 4.6,
    tags: ['agent', 'analysis', 'security', 'arca'],
    category: 'dev-tools',
    githubUrl: 'https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/dev-tools/arca-agent',
  },
  {
    id: 'arca-web3-agent',
    name: 'Arca Web3 Agent',
    description: 'Web3-native Arca agent for interacting with dApps, wallets, and on-chain protocols via natural language.',
    author: 'Arca',
    version: '1.0.0',
    downloads: 11000,
    rating: 4.4,
    tags: ['agent', 'web3', 'dapp', 'arca'],
    category: 'dev-tools',
    githubUrl: 'https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/dev-tools/arca-web3-agent',
  },
  {
    id: 'arrays-skills',
    name: 'Arrays Skills',
    description: 'Utility skill set for array manipulation, sorting, and data structure operations in smart contract contexts.',
    author: 'Open Source',
    version: '1.0.0',
    downloads: 8000,
    rating: 4.3,
    tags: ['utility', 'data-structures', 'arrays'],
    category: 'dev-tools',
    githubUrl: 'https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/dev-tools/arrays-skills',
  },
  {
    id: 'audit-claw',
    name: 'Audit Claw',
    description: 'Automated smart contract auditing tool with vulnerability detection, pattern analysis, and exploit simulation.',
    author: 'AuditClaw',
    version: '1.2.0',
    downloads: 34000,
    rating: 4.7,
    tags: ['audit', 'security', 'scanner', 'solidity'],
    category: 'dev-tools',
    githubUrl: 'https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/dev-tools/audit-claw',
  },
  {
    id: 'axiom-clawbots',
    name: 'Axiom ClawBots',
    description: 'Axiom-powered ZK coprocessor bots for trustless computation, data indexing, and verifiable queries on-chain.',
    author: 'Axiom',
    version: '1.0.0',
    downloads: 18000,
    rating: 4.6,
    tags: ['zk', 'coprocessor', 'axiom', 'indexing'],
    category: 'dev-tools',
    githubUrl: 'https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/dev-tools/axiom-clawbots',
  },
  {
    id: 'coinbase-agentkit-testnet',
    name: 'Coinbase AgentKit Testnet',
    description: 'Coinbase AgentKit configured for testnet environments with faucet access, test ETH allocation, and sandbox trades.',
    author: 'Coinbase',
    version: '1.0.0',
    downloads: 42000,
    rating: 4.8,
    tags: ['testnet', 'coinbase', 'agentkit', 'sandbox'],
    category: 'dev-tools',
    githubUrl: 'https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/dev-tools/coinbase-agentkit-testnet',
  },
  {
    id: 'cryogen',
    name: 'Cryogen',
    description: 'Low-level EVM bytecode analysis and decompilation tool for reverse engineering smart contracts.',
    author: 'Cryogen',
    version: '2.0.0',
    downloads: 22000,
    rating: 4.5,
    tags: ['bytecode', 'decompiler', 'reverse-engineering', 'evm'],
    category: 'dev-tools',
    githubUrl: 'https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/dev-tools/cryogen',
  },
  {
    id: 'crypto-agent',
    name: 'Crypto Agent',
    description: 'General-purpose crypto development agent for contract deployment, testing, and interaction workflows.',
    author: 'Open Source',
    version: '1.0.0',
    downloads: 9500,
    rating: 4.2,
    tags: ['agent', 'deployment', 'testing', 'general'],
    category: 'dev-tools',
    githubUrl: 'https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/dev-tools/crypto-agent',
  },
  {
    id: 'crypto-agent01',
    name: 'Crypto Agent 01',
    description: 'Specialized development agent v01 with Hardhat integration, test automation, and CI/CD pipeline support.',
    author: 'Open Source',
    version: '0.1.0',
    downloads: 6200,
    rating: 4.1,
    tags: ['agent', 'hardhat', 'ci-cd', 'testing'],
    category: 'dev-tools',
    githubUrl: 'https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/dev-tools/crypto-agent01',
  },
  {
    id: 'crypto-agentv2',
    name: 'Crypto Agent v2',
    description: 'Upgraded crypto dev agent with Foundry support, fuzzing integration, and advanced debugging capabilities.',
    author: 'Open Source',
    version: '2.0.0',
    downloads: 7800,
    rating: 4.3,
    tags: ['agent', 'foundry', 'fuzzing', 'debugging'],
    category: 'dev-tools',
    githubUrl: 'https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/dev-tools/crypto-agentv2',
  },
  {
    id: 'crypto-intel-docs-search',
    name: 'Crypto Intel Docs Search',
    description: 'Semantic search across crypto documentation, whitepapers, and protocol specs using vector embeddings.',
    author: 'CryptoIntel',
    version: '1.0.0',
    downloads: 14000,
    rating: 4.5,
    tags: ['docs', 'search', 'semantic', 'knowledge'],
    category: 'dev-tools',
    githubUrl: 'https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/dev-tools/crypto-intel-docs-search',
  },
  {
    id: 'crypto-intel-security-analyzer',
    name: 'Crypto Intel Security Analyzer',
    description: 'Deep security analyzer for smart contracts with symbolic execution, taint analysis, and exploit path finding.',
    author: 'CryptoIntel',
    version: '1.1.0',
    downloads: 19000,
    rating: 4.7,
    tags: ['security', 'analyzer', 'symbolic-execution', 'taint'],
    category: 'dev-tools',
    githubUrl: 'https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/dev-tools/crypto-intel-security-analyzer',
  },
  {
    id: 'crypto-intel-security-scanner',
    name: 'Crypto Intel Security Scanner',
    description: 'Fast automated scanner detecting common vulnerabilities, misconfigurations, and anti-patterns in contracts.',
    author: 'CryptoIntel',
    version: '1.2.0',
    downloads: 25000,
    rating: 4.6,
    tags: ['scanner', 'security', 'vulnerability', 'automation'],
    category: 'dev-tools',
    githubUrl: 'https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/dev-tools/crypto-intel-security-scanner',
  },
  {
    id: 'crypto-devskill',
    name: 'CryptoSkill Dev',
    description: 'Core development utilities for the CryptoSkill ecosystem including testing helpers and mock generators.',
    author: 'CryptoSkill',
    version: '1.0.0',
    downloads: 5600,
    rating: 4.2,
    tags: ['utility', 'testing', 'mocks', 'ecosystem'],
    category: 'dev-tools',
    githubUrl: 'https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/dev-tools/cryptoskill',
  },
  {
    id: 'ctf-skills',
    name: 'CTF Skills',
    description: 'Capture The Flag toolkit for blockchain security challenges with exploit templates and sandbox environments.',
    author: 'Open Source',
    version: '1.0.0',
    downloads: 16000,
    rating: 4.5,
    tags: ['ctf', 'security', 'challenges', 'exploits'],
    category: 'dev-tools',
    githubUrl: 'https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/dev-tools/ctf-skills',
  },
  {
    id: 'drpc-official-agent-skills',
    name: 'dRPC Official Agent Skills',
    description: 'Official dRPC decentralized RPC network skills for resilient multi-provider blockchain node access.',
    author: 'dRPC',
    version: '1.0.0',
    downloads: 28000,
    rating: 4.6,
    tags: ['official', 'rpc', 'decentralized', 'drpc'],
    category: 'dev-tools',
    githubUrl: 'https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/dev-tools/drpc-official-agent-skills',
  },
  {
    id: 'erc8004-expert-agent',
    name: 'ERC-8004 Expert Agent',
    description: 'Expert agent specializing in ERC-8004 identity and reputation protocol implementation and verification.',
    author: 'ERC8004',
    version: '1.0.0',
    downloads: 9000,
    rating: 4.4,
    tags: ['erc-8004', 'identity', 'reputation', 'expert'],
    category: 'dev-tools',
    githubUrl: 'https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/dev-tools/erc8004-expert-agent',
  },
  {
    id: 'eth2-quickstart',
    name: 'Eth2 Quickstart',
    description: 'One-click Ethereum 2.0 validator setup and management with automated staking, monitoring, and alerts.',
    author: 'Eth2',
    version: '2.0.0',
    downloads: 32000,
    rating: 4.7,
    tags: ['eth2', 'validator', 'staking', 'ethereum'],
    category: 'dev-tools',
    githubUrl: 'https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/dev-tools/eth2-quickstart',
  },
  {
    id: 'ethskills',
    name: 'EthSkills',
    description: 'Ethereum development skill suite with compilation, deployment, verification, and interaction helpers.',
    author: 'Open Source',
    version: '1.5.0',
    downloads: 21000,
    rating: 4.5,
    tags: ['ethereum', 'development', 'compilation', 'deployment'],
    category: 'dev-tools',
    githubUrl: 'https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/dev-tools/ethskills',
  },
  {
    id: 'ezcto-deployer',
    name: 'EzCTO Deployer',
    description: 'Zero-config smart contract deployer with automatic network detection, gas estimation, and Etherscan verification.',
    author: 'EzCTO',
    version: '1.0.0',
    downloads: 13000,
    rating: 4.4,
    tags: ['deployer', 'zero-config', 'verification', 'deployment'],
    category: 'dev-tools',
    githubUrl: 'https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/dev-tools/ezcto-deployer',
  },
  {
    id: 'furet-freelance',
    name: 'Furet Freelance',
    description: 'Freelance marketplace toolkit for crypto developers with escrow contracts, milestone tracking, and dispute resolution.',
    author: 'Furet',
    version: '1.0.0',
    downloads: 8500,
    rating: 4.3,
    tags: ['freelance', 'escrow', 'marketplace', 'contracts'],
    category: 'dev-tools',
    githubUrl: 'https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/dev-tools/furet-freelance',
  },
  {
    id: 'github-bounty',
    name: 'GitHub Bounty',
    description: 'GitHub-integrated bounty system for crypto projects with on-chain reward distribution and issue tracking.',
    author: 'Open Source',
    version: '1.0.0',
    downloads: 11000,
    rating: 4.4,
    tags: ['bounty', 'github', 'rewards', 'open-source'],
    category: 'dev-tools',
    githubUrl: 'https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/dev-tools/github-bounty',
  },
  {
    id: 'github-crypto-search',
    name: 'GitHub Crypto Search',
    description: 'Advanced GitHub search for crypto repositories, smart contracts, and developer tools with filtering and ranking.',
    author: 'Open Source',
    version: '1.0.0',
    downloads: 14500,
    rating: 4.5,
    tags: ['github', 'search', 'repositories', 'discovery'],
    category: 'dev-tools',
    githubUrl: 'https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/dev-tools/github-crypto-search',
  },
  {
    id: 'goat-sdk',
    name: 'GOAT SDK',
    description: 'Goat Onchain Agent Toolkit SDK for building AI agents with blockchain interaction, wallet management, and DeFi operations.',
    author: 'GOAT',
    version: '1.0.0',
    downloads: 24000,
    rating: 4.6,
    tags: ['sdk', 'agent', 'toolkit', 'onchain'],
    category: 'dev-tools',
    githubUrl: 'https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/dev-tools/goat-sdk',
  },
  {
    id: 'lido-mcp-builder',
    name: 'Lido MCP Builder',
    description: 'Lido staking MCP builder for creating custom Model Context Protocol integrations with Lido protocol.',
    author: 'Lido',
    version: '1.0.0',
    downloads: 17000,
    rating: 4.5,
    tags: ['lido', 'mcp', 'staking', 'builder'],
    category: 'dev-tools',
    githubUrl: 'https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/dev-tools/lido-mcp-builder',
  },
  {
    id: 'lucas-abstract',
    name: 'Lucas Abstract',
    description: 'Abstract Global Wallet development toolkit with account abstraction, paymaster integration, and smart account management.',
    author: 'Lucas',
    version: '1.0.0',
    downloads: 10000,
    rating: 4.4,
    tags: ['abstract', 'account-abstraction', 'wallet', 'smart-account'],
    category: 'dev-tools',
    githubUrl: 'https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/dev-tools/lucas-abstract',
  },
  {
    id: 'moralis-api',
    name: 'Moralis API',
    description: 'Direct Moralis API access for real-time blockchain data, NFT metadata, token balances, and wallet history.',
    author: 'Moralis',
    version: '2.0.0',
    downloads: 76000,
    rating: 4.7,
    tags: ['api', 'data', 'nft', 'wallet'],
    category: 'dev-tools',
    githubUrl: 'https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/dev-tools/moralis-api',
  },
  {
    id: 'moralis-data-api',
    name: 'Moralis Data API',
    description: 'Structured data API from Moralis for indexed blockchain events, decoded logs, and historical state queries.',
    author: 'Moralis',
    version: '1.5.0',
    downloads: 54000,
    rating: 4.6,
    tags: ['api', 'data', 'events', 'indexing'],
    category: 'dev-tools',
    githubUrl: 'https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/dev-tools/moralis-data-api',
  },
  {
    id: 'moralis-streams-api',
    name: 'Moralis Streams API',
    description: 'Real-time blockchain event streaming via Moralis with webhook delivery, filtering, and custom topic subscriptions.',
    author: 'Moralis',
    version: '1.0.0',
    downloads: 48000,
    rating: 4.6,
    tags: ['streams', 'real-time', 'webhooks', 'events'],
    category: 'dev-tools',
    githubUrl: 'https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/dev-tools/moralis-streams-api',
  },
  {
    id: 'motiv-toolbox',
    name: 'Motiv Toolbox',
    description: 'Developer toolbox for Motiv ecosystem with contract templates, testing utilities, and deployment scripts.',
    author: 'Motiv',
    version: '1.0.0',
    downloads: 9000,
    rating: 4.3,
    tags: ['toolbox', 'templates', 'scripts', 'motiv'],
    category: 'dev-tools',
    githubUrl: 'https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/dev-tools/motiv-toolbox',
  },
  {
    id: 'openzeppelin-skills',
    name: 'OpenZeppelin Skills',
    description: 'OpenZeppelin contract library skills with secure implementations of ERC standards, access control, and governance modules.',
    author: 'OpenZeppelin',
    version: '5.0.0',
    downloads: 112000,
    rating: 4.9,
    tags: ['openzeppelin', 'library', 'standards', 'security'],
    category: 'dev-tools',
    githubUrl: 'https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/dev-tools/openzeppelin-skills',
  },
  {
    id: 'petir-security-agent',
    name: 'Petir Security Agent',
    description: 'AI-powered security agent for continuous contract monitoring, anomaly detection, and threat intelligence.',
    author: 'Petir',
    version: '1.0.0',
    downloads: 14000,
    rating: 4.5,
    tags: ['security', 'agent', 'monitoring', 'threat'],
    category: 'dev-tools',
    githubUrl: 'https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/dev-tools/petir-security-agent',
  },
  {
    id: 'proveragent',
    name: 'ProverAgent',
    description: 'Formal verification agent using theorem provers to mathematically prove smart contract correctness and safety.',
    author: 'Prover',
    version: '1.0.0',
    downloads: 11000,
    rating: 4.6,
    tags: ['formal-verification', 'theorem-prover', 'correctness', 'safety'],
    category: 'dev-tools',
    githubUrl: 'https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/dev-tools/proveragent',
  },
  {
    id: 'rehash-scout',
    name: 'Rehash Scout',
    description: 'Blockchain reconnaissance tool for discovering contracts, analyzing bytecode, and mapping protocol dependencies.',
    author: 'Rehash',
    version: '1.0.0',
    downloads: 9500,
    rating: 4.3,
    tags: ['reconnaissance', 'bytecode', 'discovery', 'analysis'],
    category: 'dev-tools',
    githubUrl: 'https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/dev-tools/rehash-scout',
  },
  {
    id: 'secureth-auditor',
    name: 'Secureth Auditor',
    description: 'Comprehensive Ethereum security auditor with static analysis, dynamic testing, and manual review checklists.',
    author: 'Secureth',
    version: '2.0.0',
    downloads: 26000,
    rating: 4.7,
    tags: ['auditor', 'ethereum', 'static-analysis', 'dynamic-testing'],
    category: 'dev-tools',
    githubUrl: 'https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/dev-tools/secureth-auditor',
  },
  {
    id: 'shirdev-web3',
    name: 'ShirDev Web3',
    description: 'Web3 development environment with integrated testing, debugging, and deployment for ShirDev ecosystem projects.',
    author: 'ShirDev',
    version: '1.0.0',
    downloads: 7200,
    rating: 4.2,
    tags: ['web3', 'development', 'testing', 'shirdev'],
    category: 'dev-tools',
    githubUrl: 'https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/dev-tools/shirdev-web3',
  },
  {
    id: 'smart-contract-security-scanner',
    name: 'Smart Contract Security Scanner',
    description: 'Enterprise-grade scanner detecting reentrancy, overflow, access control flaws, and business logic vulnerabilities.',
    author: 'Security',
    version: '3.0.0',
    downloads: 58000,
    rating: 4.8,
    tags: ['scanner', 'enterprise', 'reentrancy', 'access-control'],
    category: 'dev-tools',
    githubUrl: 'https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/dev-tools/smart-contract-security-scanner',
  },
  {
    id: 'smart-contract-security',
    name: 'Smart Contract Security',
    description: 'Complete smart contract security suite combining static analysis, fuzzing, and symbolic execution in one toolkit.',
    author: 'Security',
    version: '2.5.0',
    downloads: 45000,
    rating: 4.7,
    tags: ['security', 'suite', 'fuzzing', 'symbolic-execution'],
    category: 'dev-tools',
    githubUrl: 'https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/dev-tools/smart-contract-security',
  },
  {
    id: 'solidity-audit-agent',
    name: 'Solidity Audit Agent',
    description: 'AI agent trained on thousands of audit reports for Solidity contracts, detecting patterns and suggesting fixes.',
    author: 'Solidity',
    version: '1.3.0',
    downloads: 31000,
    rating: 4.6,
    tags: ['solidity', 'audit', 'ai-agent', 'patterns'],
    category: 'dev-tools',
    githubUrl: 'https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/dev-tools/solidity-audit-agent',
  },
  {
    id: 'tokr-tokenization-agent',
    name: 'Tokr Tokenization Agent',
    description: 'Real-world asset tokenization agent for creating compliant security tokens, NFTs, and fractional ownership contracts.',
    author: 'Tokr',
    version: '1.0.0',
    downloads: 12000,
    rating: 4.4,
    tags: ['tokenization', 'rwa', 'security-tokens', 'compliance'],
    category: 'dev-tools',
    githubUrl: 'https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/dev-tools/tokr-tokenization-agent',
  },
  {
    id: 'trailofbits-official-building-secure-contracts',
    name: 'Trail of Bits Secure Contracts',
    description: 'Official Trail of Bits skill for building secure smart contracts with best practices, patterns, and testing frameworks.',
    author: 'Trail of Bits',
    version: '2.0.0',
    downloads: 39000,
    rating: 4.8,
    tags: ['official', 'secure-contracts', 'best-practices', 'trailofbits'],
    category: 'dev-tools',
    githubUrl: 'https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/dev-tools/trailofbits-official-building-secure-contracts',
  },
  {
    id: 'trailofbits-skills',
    name: 'Trail of Bits Skills',
    description: 'Comprehensive Trail of Bits security toolkit with Slither, Echidna, and Manticore integration for contract analysis.',
    author: 'Trail of Bits',
    version: '1.5.0',
    downloads: 33000,
    rating: 4.7,
    tags: ['trailofbits', 'slither', 'echidna', 'manticore'],
    category: 'dev-tools',
    githubUrl: 'https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/dev-tools/trailofbits-skills',
  },
  {
    id: 'vulnerability-hunt-agent',
    name: 'Vulnerability Hunt Agent',
    description: 'AI bug bounty hunter agent that automatically finds and reports vulnerabilities in deployed smart contracts.',
    author: 'Open Source',
    version: '1.0.0',
    downloads: 18000,
    rating: 4.5,
    tags: ['bug-bounty', 'vulnerability', 'hunting', 'agent'],
    category: 'dev-tools',
    githubUrl: 'https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/dev-tools/vulnerability-hunt-agent',
  },
  {
    id: 'wazuh-agent-docker',
    name: 'Wazuh Agent Docker',
    description: 'Dockerized Wazuh security monitoring agent for blockchain infrastructure with SIEM integration and threat detection.',
    author: 'Wazuh',
    version: '1.0.0',
    downloads: 15000,
    rating: 4.4,
    tags: ['docker', 'monitoring', 'siem', 'infrastructure'],
    category: 'dev-tools',
    githubUrl: 'https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/dev-tools/wazuh-agent-docker',
  },
  {
    id: 'zkproofport-prover',
    name: 'ZKProofPort Prover',
    description: 'Zero-knowledge proof generation and verification toolkit with support for multiple ZK schemes and circuits.',
    author: 'ZKProofPort',
    version: '1.0.0',
    downloads: 20000,
    rating: 4.6,
    tags: ['zk', 'proof', 'circuits', 'verification'],
    category: 'dev-tools',
    githubUrl: 'https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/dev-tools/zkproofport-prover',
  },
];